const comments = [
  {
    name: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20watermelon%20character%20avatar%20icon%2C%20minimalist%20flat%20design%2C%20warm%20colors%2C%20simple%20background%2C%20kawaii%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    time: '3分钟前',
    content: '终于有人把这个瓜整理清楚了！之前看了那么多零散的51吃瓜黑料视频，就你们这里最全最清晰，已转发给一起吃瓜的姐妹！',
    likes: '2.3万',
  },
  {
    name: '深夜瓜田守望者',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20cat%20with%20binoculars%20avatar%20icon%2C%20minimalist%20flat%20design%2C%20warm%20amber%20colors%2C%20simple%20background%2C%20playful%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    time: '15分钟前',
    content: '51吃瓜黑料这个站真的绝了，爆料速度快得飞起，关键实锤多、不瞎编。每天刷一遍黑料视频，比刷剧还上头！',
    likes: '1.8万',
  },
  {
    name: '娱乐圈观察员',
    avatar: 'https://readdy.ai/api/search-image?query=Detective%20magnifying%20glass%20avatar%20icon%2C%20minimalist%20flat%20design%2C%20warm%20crimson%20colors%2C%20simple%20background%2C%20modern%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    time: '28分钟前',
    content: '老吃瓜人了，这个51吃瓜视频平台确实靠谱。黑料爆料视频更新快不说，话题讨论区也热闹，能找到一帮志同道合的瓜友。',
    likes: '1.5万',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            来自51吃瓜黑料社区的真实吃瓜群众声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}